import { blockedApi } from "api/blockedApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useBlocked = (skip: number, limit: number, searchPhrase: string = "") => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.BLOCKED(skip, limit, searchPhrase),
    queryFn: () => blockedApi.fetch(skip, limit, searchPhrase),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.BLOCKED(skip, limit, searchPhrase),
    });
  };

  return { invalidate, isLoading, isFetching, blocked: data?.data.data ?? [], total: data?.data.total ?? 0 };
};
